import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceRight2.vue?vue&type=template&id=6196e7f8&"
import script from "./FaceDirectionResultEffectFaceRight2.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceRight2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports